var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inbox--name"},[_c('i',{class:_vm.computedInboxClass}),_vm._v("\n  "+_vm._s(_vm.inbox.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }